import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {BaseValue} from '@mintdata/mint-kit/api/values/BaseValue';

export class ABinaryData extends BaseValue
{
    public constructor(public readonly value:Uint8Array)
    {
        super(Type.BinaryData);
    }

    public toString():string
    {
        return this.value != null ? this.value.toString() : null;
    }

    public toValue():string
    {
        return `{"value":${this.value}}`;
    }

    public isEqualTo(other:IValue):boolean
    {
        throw new Error('not implemented yet');
        // return other &&
        //     other instanceof Uint8Array &&
        //     this.value === other.value;
    }

    public compareTo(other:IValue):number
    {
        throw new Error('not implemented yet');
        // if( this.isEqualTo(other) )
        //     return 0;
        //
        // if( other &&
        //     other instanceof ABoolean )
        // {
        //     return (this.value > other.value) ? 1 : -1;
        // }
        //
        // return -1;
    }

    public clone():IValue
    {
        throw new Error('not implemented yet');
    }

    public static fromString(value:string):Uint8Array
    {
        throw new Error('not implemented yet');
        // value = (value || '').toLowerCase().trim();
        //
        // if( value === 'true' )
        //     return ABoolean.true();
        //
        // return ABoolean.false();
    }

    public static circularRefResolver(value:string):IValue
    {
        // KEEP_ALIVE! Fix for resolving import circular dependencies for AError and ABaseValue
        return new AError('ERROR: Deprecated');
    }
}
